// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Ekuv3","container":"styles_container__haVrh","title":"styles_title__2_iLp","wrapper":"styles_wrapper__249yL","answer":"styles_answer__2kspi"};